var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "deviceSelect"
  }, [_c('el-select', {
    ref: "deviceSelects",
    class: {
      transformIcon: !_vm.isHost,
      openSelect: _vm.openSelect && !_vm.isHost
    },
    attrs: {
      "popper-append-to-body": _vm.appendToBody
    },
    on: {
      "visible-change": _vm.visibleChange,
      "change": _vm.handleAudioOrVideo
    },
    model: {
      value: _vm.deviceId,
      callback: function ($$v) {
        _vm.deviceId = $$v;
      },
      expression: "deviceId"
    }
  }, [_c('div', {
    staticClass: "titleBox"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._l(_vm.data, function (item) {
    return _c('el-option', {
      key: item.deviceId,
      attrs: {
        "label": item.label,
        "disabled": _vm.type === 'video' ? _vm.State.initCamera : false,
        "value": item.deviceId
      }
    });
  }), _vm.type === 'audio' ? _c('el-divider') : _vm._e(), _vm.type === 'audio' ? _c('div', {
    staticClass: "audioSetting",
    on: {
      "click": _vm.showAudioSetting
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sound"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('common.audioSetting')))])]) : _vm._e()], 2), _vm.audiSettingInfo.show ? _c('AudioSetting', {
    ref: "audioSetting",
    attrs: {
      "audiSettingInfo": _vm.audiSettingInfo
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };